import { injectGlobal } from '@bd/bdui-styles/emotion';
import colors from './colors';

injectGlobal(`
  @media (min-width: 1400px) {
    .container {
      max-width: 1300px;
    }
  }
  @media (min-width: 1600px) {
    .container {
      max-width: 1500px;
    }
  }
  .btn {
    background-color: ${colors.color1};
    border-radius: 3px;
    border: 3px solid ${colors.color2};
    color: #FFFFFF;
    padding: 12px 18px;
    font-weight: bold;
    letter-spacing: 1.88px;
    line-height: 18px;
    text-transform: uppercase;
    &:hover {
      background-color: ${colors.color1Lighter};
      color: #FFFFFF;
    }
  }
  .btn-hollow {
    background-color: transparent;
    border: 1px solid ${colors.color1};
    color: ${colors.color2};
    background-image: none;
    padding: 15px 30px;
  }
  .leaflet-popup-content-wrapper {
    border-radius: 0 !important;

    leaflet-popup-content {
      min-width: fit-content;
    }
  }
`);



// WEBPACK FOOTER //
// ./src/styles/reset.js